import { useContext } from 'react';
import { GeolocationContext } from '../contexts/geolocation.context';

export function useGeolocation() {
  const ctx = useContext(GeolocationContext);

  if (!ctx) {
    throw new Error('useGeolocation must be used within a GeolocationProvider');
  }

  return ctx;
}
